import { Route } from "react-router-dom";

import { routes } from "constants/routes";
import RateTrend from "features/main/RateTrend";
import RateTrendViewGraph from "features/main/RateTrend/ViewGraph";

export default function RateTrendRoutes() {
  return (
    <Route path={routes.RATE_TREND}>
      <Route path="" element={<RateTrend />} />
      <Route path="graph" element={<RateTrendViewGraph />} />
    </Route>
  );
}
